<template>
  <b-embed
          controls
    :type="typeOfPlayer"
    aspect="16by9"
    id="video-modal-video"
    :src="videoUrl"
    allowfullscreen
    allow="autoplay; geolocation; microphone; camera"
    @ended="playNextVideo"
  ></b-embed>
</template>

<script>
export default {
  name: "video-player",
  props: {
    typeOfPlayer: String,
    videoUrl: String
  },
    methods:{
        playNextVideo(){
            this.$emit("playNextVideo");
        }
    }
};
</script>

<style scoped></style>
